import React from "react";

const QuestionMarkIcon = ({ width, height, color }) => {
  return (
    <svg
      width="63"
      height="63"
      viewBox="0 0 63 63"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="31.5" cy="31.5" r="31.5" fill="#00008B" fillOpacity="0.1" />
      <path
        d="M29.9552 43.6611C29.3092 43.6611 28.7866 44.1859 28.7866 44.8281C28.7866 45.4746 29.309 45.9998 29.9552 45.9998C30.6009 45.9998 31.1238 45.4746 31.1238 44.8281C31.1238 44.1859 30.6011 43.6611 29.9552 43.6611Z"
        fill="#FF4400"
      />
      <path
        d="M31.9993 16C26.8575 16 22.6743 20.1832 22.6743 25.325C22.6743 25.9389 23.172 26.4366 23.7859 26.4366C24.3997 26.4366 24.8974 25.9389 24.8974 25.325C24.8974 21.409 28.0833 18.2231 31.9993 18.2231C35.9152 18.2231 39.101 21.409 39.101 25.325C39.101 29.2413 35.9152 32.4274 31.9993 32.4274C31.961 32.4274 31.9229 32.4294 31.8854 32.4332C30.2362 32.4925 28.9082 33.8204 28.849 35.4695C28.8451 35.507 28.8432 35.5449 28.8432 35.5834V40.1662C28.8432 40.7801 29.3409 41.2778 29.9547 41.2778C30.5686 41.2778 31.0663 40.7801 31.0663 40.1662V35.5834C31.0663 35.069 31.4848 34.6505 31.9993 34.6505C37.141 34.6505 41.3241 30.4671 41.3241 25.325C41.3241 20.1832 37.1412 16 31.9993 16Z"
        fill="#FF4400"
      />
    </svg>
  );
};

export default QuestionMarkIcon;
